import { getOneSharedEnv } from '@/general/src/other/sharedEnv.js'
import { createRoutyThings } from 'svag-routy'

const { createRoute } = createRoutyThings({
  baseUrl: getOneSharedEnv('WEBAPP_URL'),
  definitionParamsPrefix: ':',
})

// General

export const testRoute = createRoute(`/test`)

export const homeRoute = createRoute(`/`)
export const docsRoute = homeRoute.createRoute(`/docs`)

export const agentRoute = homeRoute.createRoute(`/app`)
export const adminRoute = homeRoute.createRoute(`/admin`)

// Docs

export const policyRoute = docsRoute.createRoute(`/policy`)
export const termsRoute = docsRoute.createRoute(`/terms`)

// Auth

export const agentAuthRoute = agentRoute.createRoute(`/auth`)
export const agentSignInRoute = agentAuthRoute.createRoute(`/sign-in`)
export const agentSignUpRoute = agentAuthRoute.createRoute(`/sign-up`)
export const agentSignOutRoute = agentAuthRoute.createRoute(`/sign-out`)
export const agentRestorePasswordRoute = agentAuthRoute.createRoute(`/restore-password`)
export const agentResetPasswordRoute = agentAuthRoute.createRoute(`/reset-password`)

export const adminAuthRoute = adminRoute.createRoute(`/auth`)
export const adminSignInRoute = adminAuthRoute.createRoute(`/sign-in`)
export const adminSignUpRoute = adminAuthRoute.createRoute(`/sign-up`)
export const adminSignOutRoute = adminAuthRoute.createRoute(`/sign-out`)
export const adminRestorePasswordRoute = adminAuthRoute.createRoute(`/restore-password`)
export const adminResetPasswordRoute = adminAuthRoute.createRoute(`/reset-password`)

// Agent

// export const agentDashboardRoute = agentRoute.createRoute(`/dashboard`)
export const agentSettingsRoute = agentRoute.createRoute(`/settings`)
export const agentAccountRoute = agentRoute.createRoute(`/account`)
export const agentSubscriptionRoute = agentRoute.createRoute(`/subscription`)
export const agentDashboardRoute = agentAccountRoute

// Admin

// export const adminDashboardRoute = adminRoute.createRoute(`/dashboard`)
export const adminAccountRoute = adminRoute.createRoute(`/account`)
export const adminSettingsRoute = adminRoute.createRoute(`/settings`)
export const adminActionLogsRoute = adminRoute.createRoute(`/action-logs`)

// Admin organization

const adminOrganizationsRoute = adminRoute.createRoute(`/organization`)
export const adminOrganizationListRoute = adminOrganizationsRoute.createRoute(`/list`)
export const adminOrganizationNewRoute = adminOrganizationsRoute.createRoute(`/new`)
export const adminOrganizationViewRoute = adminOrganizationsRoute.createRoute({
  params: ['organizationSn'],
  getter: ({ organizationSn }) => `/view/${organizationSn}`,
})

// Admin agent

const adminAgentRoute = adminRoute.createRoute(`/agent`)
export const adminAgentListRoute = adminAgentRoute.createRoute(`/list`)
export const adminAgentViewRoute = adminAgentRoute.createRoute({
  params: ['agentSn'],
  getter: ({ agentSn }) => `/view/${agentSn}`,
})
export const adminAgentEditRoute = adminAgentRoute.createRoute({
  params: ['agentSn'],
  getter: ({ agentSn }) => `/edit/${agentSn}`,
})
export const adminAgentNewRoute = adminAgentRoute.createRoute(`/new`)
export const adminDashboardRoute = adminAgentListRoute

const adminAdminRoute = adminRoute.createRoute(`/admin`)
export const adminAdminListRoute = adminAdminRoute.createRoute(`/list`)
export const adminAdminViewRoute = adminAdminRoute.createRoute({
  params: ['adminSn'],
  getter: ({ adminSn }) => `/view/${adminSn}`,
})
export const adminAdminEditRoute = adminAdminRoute.createRoute({
  params: ['adminSn'],
  getter: ({ adminSn }) => `/edit/${adminSn}`,
})
export const adminAdminNewRoute = adminAdminRoute.createRoute(`/new`)

// Upgrade post

const adminUpgradePostRoute = adminRoute.createRoute(`/upgrade-post`)
export const adminUpgradePostListRoute = adminUpgradePostRoute.createRoute(`/list`)
export const adminUpgradePostNewRoute = adminUpgradePostRoute.createRoute(`/new`)
export const adminUpgradePostEditRoute = adminUpgradePostRoute.createRoute({
  params: ['upgradePostSn'],
  getter: ({ upgradePostSn }) => `/edit/${upgradePostSn}`,
})
export const adminUpgradePostViewRoute = adminUpgradePostRoute.createRoute({
  params: ['upgradePostSn'],
  getter: ({ upgradePostSn }) => `/view/${upgradePostSn}`,
})
const publicUpgradePostRoute = homeRoute.createRoute(`/upgrade-post`)
export const publicUpgradePostListRoute = publicUpgradePostRoute.createRoute(`/list`)
export const publicUpgradePostViewRoute = publicUpgradePostRoute.createRoute({
  params: ['upgradePostSn'],
  getter: ({ upgradePostSn }) => `/view/${upgradePostSn}`,
})

// specific

type WithSnOrNull = { sn: number } | null
export const getRoute = ({
  viewerType,
  abs,
  agent,
  organization,
  admin,
}: {
  viewerType: 'agent' | 'admin'
  abs?: boolean
  agent?: WithSnOrNull
  organization?: WithSnOrNull
  admin?: WithSnOrNull
}) => {
  if (viewerType === 'admin') {
    if (agent) {
      return adminAgentEditRoute.get({ agentSn: agent.sn, abs })
    }
    if (admin) {
      return adminAdminEditRoute.get({ adminSn: admin.sn, abs })
    }
    if (organization) {
      return adminOrganizationViewRoute.get({ organizationSn: organization.sn, abs })
    }
  }
  // if (viewerType === 'agent') {
  //   if (organization) {
  //     return agentOrganizationViewRoute.get({ organizationSn: organization.sn, abs })
  //   }
  // }
  return undefined
}
